import { createContext, useContext, useState, useCallback } from "react";
import en from "@/locales/en.json";
import fil from "@/locales/fil.json";

const translations = { en, fil };
const STORAGE_KEY = "setplay_lang";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "en";
    } catch {
      return "en";
    }
  });

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    try {
      localStorage.setItem(STORAGE_KEY, newLang);
    } catch {}
  }, []);

  const t = useCallback((key) => {
    const keys = key.split(".");
    let val = translations[lang];
    for (const k of keys) {
      if (val && typeof val === "object") val = val[k];
      else return key;
    }
    return val || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
